<template>
  <div>
    <form class="search-tab-form row margin-top-2" @submit.prevent="onSearch" :class="{'padding-bottom-2': $v.$invalid}">
      <div class="columns margin-right-2" v-if="isAccountTypeParent">
        <label>Subconta</label>            
        <multiselect
            v-model="subaccount"
            :options="subaccountsSorted"             
            :placeholder="$t('SEARCH.FORM.PLACEHOLDER_ALL.FEMALE')" 
            track-by="id"
            label="name"
            class="no-margin multiselect-wrap--small"
        >
          <template #noResult>
            <span>{{ $t('SEARCH.FORM.OPTIONS_SELECT.NO_RESULTS') }}</span>
          </template>
        </multiselect>
      </div>
      <div class="columns margin-right-2" v-if="fields.includes('name')">
        <label :class="{ error: $v.name.$error }">
          {{ $t('SEARCH.FORM.LABEL.NAME') }}
          <input
            v-model.trim="name"
            type="text"
            name="name"
            @input="$v.name.$touch"
          />
          <span v-if="$v.name.$error" class="message">
              {{ $t('SEARCH.FORM.ERROR.MIN_LENGTH') }}
          </span>
        </label>        
      </div>
      <div class="columns margin-right-2" v-if="fields.includes('phone')">
        <label :class="{ error: $v.phone.$error }">
          {{ $t('SEARCH.FORM.LABEL.PHONE') }}
          <input
            v-model.trim="phone"
            type="text"
            name="phone"
            @input="$v.phone.$touch"
          />
          <span v-if="$v.phone.$error" class="message">
            {{ $t('SEARCH.FORM.ERROR.MIN_LENGTH_NUMBER') }}
          </span>  
        </label>        
      </div>
      <div class="columns margin-right-2" v-if="fields.includes('email')">
        <label :class="{ error: $v.email.$error }">
          {{ $t('SEARCH.FORM.LABEL.EMAIL') }}
          <input
            v-model.trim="email"
            type="text"
            name="email"
            @input="$v.email.$touch"
          />
          <span v-if="$v.email.$error" class="message">
            {{ $t('SEARCH.FORM.ERROR.MIN_LENGTH') }}
          </span>
        </label>        
      </div>
      <div class="columns margin-right-2" v-if="fields.includes('term')">        
        <label :class="{ error: $v.term.$error }">
            {{ $t('SEARCH.FORM.LABEL.MESSAGE_TERM') }}
            <input
            v-model.trim="term"
            type="text"
            name="term"
            @input="$v.term.$touch"
            />
            <span v-if="$v.term.$error" class="message">
                {{ $t('SEARCH.FORM.ERROR.MIN_LENGTH') }}
            </span>
        </label>   
      </div>
      <div class="columns margin-right-2 search-tab-form-column-sender_type" v-if="fields.includes('sender_type')">
        <label>{{ $t('SEARCH.FORM.LABEL.SENDER_TYPE') }}</label>
        <multiselect
            v-model="sender_type"
            :options="senderTypes"
            :placeholder="$t('SEARCH.FORM.PLACEHOLDER_ALL.MALE')"
            track-by="id"
            label="name"
            class="no-margin multiselect-wrap--small"            
        >
          <template #noResult>
            <span>{{ $t('SEARCH.FORM.OPTIONS_SELECT.NO_RESULTS') }}</span>
          </template>
        </multiselect>
      </div>
      <div class="columns margin-right-2 search-tab-form-column-private_message" v-if="fields.includes('private_message')">
        <label>{{ $t('SEARCH.FORM.LABEL.PRIVATE_MESSAGE') }}</label>            
        <multiselect
            v-model="private_message"
            :options="messagePrivateOptions"
            :placeholder="$t('SEARCH.FORM.PLACEHOLDER_ALL.FEMALE')"
            track-by="id"
            label="name"
            class="no-margin multiselect-wrap--small"            
        >
          <template #noResult>
            <span>{{ $t('SEARCH.FORM.OPTIONS_SELECT.NO_RESULTS') }}</span>
          </template>
        </multiselect>
        
      </div>
      
      <div class="columns margin-right-2" v-if="fields.includes('inbox')">
        <label>{{ $t('SEARCH.FORM.LABEL.INBOX') }}</label>            
        <multiselect
            v-if="!isAccountTypeParent"
            v-model="inbox"
            :options="inboxes"            
            :close-on-select="true"
            :placeholder="$t('SEARCH.FORM.PLACEHOLDER_ALL.FEMALE')"
            :loading="inboxesUiFlags.isFetching"
            track-by="id"
            label="name"
            class="no-margin multiselect-wrap--small"
        >
          <template #noResult>
            <span>{{ $t('SEARCH.FORM.OPTIONS_SELECT.NO_RESULTS') }}</span>
          </template>
        </multiselect>
        <multiselect
            v-else
            v-model="inbox"
            :options="inboxesAutoComplete"            
            :close-on-select="true"
            :placeholder="$t('SEARCH.FORM.PLACEHOLDER_ALL.FEMALE')"
            :loading="inboxesUiFlags.isFetching"
            :clear-on-select="false"
            :searchable="true"          
            :preserve-search="true"
            :group-select="false"
            track-by="id"
            label="name"
            class="no-margin multiselect-wrap--small"
            group-values="inboxes" group-label="account_name"
            @search-change="asyncFindInboxes"          
        > 
          <template #noResult>
            <span v-if="inboxesSearchQuery.length >= 3">{{ $t('SEARCH.FORM.OPTIONS_SELECT.NO_RESULTS') }}</span>
            <span v-else>{{ $t('SEARCH.FORM.OPTIONS_SELECT.MIN_LENGTH_SEARCH') }}</span>
          </template>
          <template #noOptions>
            <span>{{ $t('SEARCH.FORM.OPTIONS_SELECT.MIN_LENGTH_SEARCH') }}</span>
          </template>
        </multiselect>
      </div>
      <div class="columns margin-right-2 search-tab-form-column-calendar" v-if="fields.includes('date_range')">
        <label>{{ $t('SEARCH.FORM.LABEL.DATE_INTERVAL') }}</label>
        <DatePicker
            ref="datepicker"
            v-model="tempDateRange"
            range
            format="DD/MM/YYYY"
            :enable-time-picker="false"
            :partial-range="true"
            :auto-apply="false"
            :min-date="minSelectableDate"
            :max-date="maxSelectableDate"          
            :multi-calendars="false"
            :disabled-date="isDateDisabled"
            @pick="onCalendarPicker"
            @open="onOpenCalendar"
        >
            <template #input>
            <input @click="openCalendar" readonly type="text" :value="formattedDateRange">
            </template>
        </DatePicker>
      </div>
      <div class="columns search-tab-form-column-submit">
        <woot-submit-button
            :disabled="disabledSubmit"
            :button-text="$t('SEARCH.BUTTON')"        
        />
      </div>     
    </form>
    <div class="row" v-if="minimalFieldsNames">
      <div class="help-text margin-top-2">
        {{ $t('SEARCH.HELP_MINIMAL_FIELDS', { fields: minimalFieldsNames }) }}
      </div>
    </div>
  </div>  
</template>

<script>
import { mapGetters } from 'vuex';

import {addDays,subDays,endOfDay} from 'date-fns';
import { minLength } from 'vuelidate/lib/validators';
import timeMixin from 'dashboard/mixins/time';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  mixins: [timeMixin],
  components: {    
    DatePicker    
  },
  props: {
    fields: {
      type: Array,
    },
    // Quando true, o dia atual não pode ser selecionado (ex.: pesquisa via BigQuery na conta mãe)
    excludeToday: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const today = this.excludeToday ? subDays(new Date(), 1) : new Date();
    const sevenDaysAgo = subDays(today, 7);

    return {      
      name: '',
      phone: '',
      email: '',     
      term: '',
      inbox: null,
      sender_type: null,
      private_message: null, 
      searched: false,
      senderTypes: [
        { id: 'User', name: 'Usuário' },
        { id: 'Contact', name: 'Cliente' },
      ],
      messagePrivateOptions: [
        { id: 1, name: 'Sim' },
        { id: 0, name: 'Não' },
      ],
      tempDateRange: [sevenDaysAgo, today],
      customDateRange: [sevenDaysAgo, today],
      firstDateSelected: null,
      subaccount: null,
      inboxesAutoComplete: [],
      inboxesSearchQuery: '',
    };
  },
  validations: {
    name: {      
      minLength: minLength(3)      
    },
    phone: {
      minNumbersLength(value) {
        if(!value || value.trim() === ''){
          return true;
        }
        return value.replace(/\D/g, '').length >= 3;
      },
    },
    email: {      
      minLength: minLength(3)
    },
    term: {      
      minLength: minLength(3)      
    }
  },
  computed: {
    ...mapGetters({      
      inboxes: 'inboxes/getInboxes',
      uiFlags: 'conversationSearch/getUIFlags',
      isAccountTypeParent: 'isAccountTypeParent',
      subaccounts: 'subaccounts/getSubaccounts',
      subaccountUiFlags: 'subaccounts/getUIFlags',
      inboxesUiFlags: 'inboxes/getUIFlags'      
    }),
    disabledSubmit() {      
      return this.uiFlags.isFetching || (this.allMinimalInputsSearchEmpty && !this.searched);
    },
    allMinimalInputsSearchEmpty() {      
      const fieldsWithValue = this.minimalFieldsSearch.filter((field) => {
        return this[field] && (this[field] !== null && typeof(this[field]) != 'string' || (typeof(this[field]) == 'string' && this[field].trim() != ''));
      });
      return fieldsWithValue.length === 0;    
    },
    minimalFieldsSearch(){
      return ['name', 'phone', 'email', 'term'].filter(filter => this.fields.includes(filter));      
    },
    today() {
      return endOfDay(new Date());
    },
    minSelectableDate() {
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(this.today.getFullYear() - 1);
      return oneYearAgo;
    },
    maxSelectableDate() {
      return this.excludeToday ? endOfDay(subDays(new Date(), 1)) : this.today;
    },
    formattedDateRange() {
      const [start, end] = this.tempDateRange;
      if (!start || !end)
        return '-';
      const format = d =>
        new Date(d).toLocaleDateString('pt-BR', {});
      return `${format(start)} - ${format(end)}`;
    },
    minimalFieldsNames(){
      if(!this.allMinimalInputsSearchEmpty || this.minimalFieldsSearch.length == 0 || this.searched){
        return null;
      }
      const fieldsNames = [
        { key: 'name', label: this.$t('SEARCH.FORM.LABEL.NAME') },
        { key: 'phone', label: this.$t('SEARCH.FORM.LABEL.PHONE') },
        { key: 'email', label: this.$t('SEARCH.FORM.LABEL.EMAIL') },
        { key: 'term', label: this.$t('SEARCH.FORM.LABEL.MESSAGE_TERM') },
      ].filter((field) => this.minimalFieldsSearch.includes(field.key)).map(field => field.label);
      
      return fieldsNames.join(' ou ');
    },
    subaccountsSorted(){
      return [...this.subaccounts].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
    }
  },  
  mounted() {
    this.private_message = this.messagePrivateOptions.find(option => option.id === 0);
    if(this.isAccountTypeParent && !this.subaccountUiFlags.isFetching && this.subaccounts.length === 0){
      this.$store.dispatch('subaccounts/get');
    }
  },
  methods: {
    onSearch() {
      this.$v.$touch();            
      if (this.$v.$invalid) {
        return;
      }
      if(this.allMinimalInputsSearchEmpty){
        this.$emit('search', null);
        this.searched = false;
        return;
      }      
      this.$emit('search', {
        ...this.$data,
        ...{
          phone: this.phone && this.phone.replace(/\D/g, '') != '' ? this.phone.replace(/\D/g, '') : null,
        }
      });
      this.searched = true;
    },
    openCalendar() {
      this.$refs.datepicker.openMenu?.();
    },
    isDateDisabled(date) {
      if(date > this.minSelectableDate && date < this.maxSelectableDate){
        if(!this.firstDateSelected){
          return false;
        }
        const minDateRange = subDays(this.firstDateSelected, 31);
        const maxDateRange = addDays(this.firstDateSelected, 31);
        return (date < minDateRange || date > maxDateRange);        
      }
      return true;
    },
    onCalendarPicker(date){
      if(!this.firstDateSelected){
        this.firstDateSelected = date;
      }
    },
    onOpenCalendar(){
      this.firstDateSelected = null;
    },
    async asyncFindInboxes (query) {
      this.inboxesSearchQuery = query;
      if(query.trim() === '' || query.trim().length < 3){
        this.inboxesAutoComplete = [];
        return;
      }
      this.inboxesAutoComplete = [];
      await this.$store.dispatch('inboxes/search', {
        search: encodeURIComponent(query),
        include_subaccounts: this.isAccountTypeParent,
        limit: 100
      });
      let groupedInboxes = [];
      this.inboxes.forEach(inbox => {
        let index = groupedInboxes.findIndex(item => item.account_name === inbox.account.name);
        if(index === -1){
          groupedInboxes.push({
            account_name: inbox.account.name,
            inboxes: [inbox]
          });
        } else {
          groupedInboxes[index].inboxes.push(inbox);
        }
      });
      this.inboxesAutoComplete = groupedInboxes;
    }
  },
};
</script>
<style lang="scss" scoped> 
  .search-tab-form{
    align-items: center;
    .columns{
      width: calc(100% - 100px);
      input, .multiselect-wrap--small .multiselect{
        margin: 0;
      }
      &.search-tab-form-column-calendar{
        min-width: 230px;
        max-width: 230px;
      }
      &.search-tab-form-column-submit{
        max-width: 100px;
      }
      .mx-datepicker-range{
        width: 100%;
        input[readonly]{
          background: #fff;
          cursor: pointer;
        }
      }
      button[type="submit"]{
        margin-top: 24px;
      }
      label.error{
        position: relative;
        span.message{
          position: absolute;
          bottom: -35px;
        }
      }
    }
  }
</style>

